import { isMobile, isTablet as isMobileTablet } from 'react-device-detect'

export const phoneWidth = "500px";

export function isPhone() {
    return isMobile && !isMobileTablet;
}
export function isTablet() {
    return isMobileTablet;
}